/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AboutUserFormCardQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type AboutUserFormCardQuery = {
  __typename?: 'Query'
  backofficeOrganizations: Array<{
    __typename?: 'BackofficeOrganization'
    id: string
    name: string
  }>
}

export const AboutUserFormCardDocument = gql`
    query AboutUserFormCard {
  backofficeOrganizations {
    id
    name
  }
}
    `

/**
 * __useAboutUserFormCardQuery__
 *
 * To run a query within a React component, call `useAboutUserFormCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAboutUserFormCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAboutUserFormCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useAboutUserFormCardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AboutUserFormCardQuery,
    AboutUserFormCardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AboutUserFormCardQuery,
    AboutUserFormCardQueryVariables
  >(AboutUserFormCardDocument, options)
}
export function useAboutUserFormCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AboutUserFormCardQuery,
    AboutUserFormCardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AboutUserFormCardQuery,
    AboutUserFormCardQueryVariables
  >(AboutUserFormCardDocument, options)
}
// @ts-ignore
export function useAboutUserFormCardSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AboutUserFormCardQuery,
    AboutUserFormCardQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AboutUserFormCardQuery,
  AboutUserFormCardQueryVariables
>
export function useAboutUserFormCardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AboutUserFormCardQuery,
        AboutUserFormCardQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AboutUserFormCardQuery | undefined,
  AboutUserFormCardQueryVariables
>
export function useAboutUserFormCardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AboutUserFormCardQuery,
        AboutUserFormCardQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AboutUserFormCardQuery,
    AboutUserFormCardQueryVariables
  >(AboutUserFormCardDocument, options)
}
export type AboutUserFormCardQueryHookResult = ReturnType<
  typeof useAboutUserFormCardQuery
>
export type AboutUserFormCardLazyQueryHookResult = ReturnType<
  typeof useAboutUserFormCardLazyQuery
>
export type AboutUserFormCardSuspenseQueryHookResult = ReturnType<
  typeof useAboutUserFormCardSuspenseQuery
>
export type AboutUserFormCardQueryResult = Apollo.QueryResult<
  AboutUserFormCardQuery,
  AboutUserFormCardQueryVariables
>
